import React from 'react';
import { useWhatsappRedirect } from '../../hooks/useWhatsappRedirect';
import Error from '../../components/Error';

const WhatsappRedirect = ({ queryParams }) => {
  const { error } = useWhatsappRedirect(queryParams);

  if (error) {
    return  <Error message={error.message} />;
  }

  return null;
};

export default WhatsappRedirect;
